const contestTypeOptions = [
	{ label: 'Submitted & Issued', value: '0' },
	{ label: 'Issued', value: '1' },
	{ label: 'Submitted', value: '2' },
];

export {
	contestTypeOptions,
}
